import React from "react";

export default function FILTVTVFrame({ children }) {
    return (
        <div className="relative rounded-2xl overflow-hidden border border-zinc-800 shadow-2xl shadow-purple-900/30 bg-black">
            <div className="absolute inset-0 pointer-events-none bg-gradient-to-tr from-transparent via-transparent to-purple-500/10" />

            <div className="absolute top-0 left-0 z-30 bg-red-600 px-3 py-1 text-[10px] sm:text-xs font-bold rounded-br-lg">
                🔴 LIVE
            </div>

            {children}
        </div>
    );
}
